"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es7.string.pad-start");
var _syncGoodsLog = require("@/api/goods/syncGoodsLog");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: '操作日志',
  data: function data() {
    return {
      loading: false,
      logList: [],
      total: 0,
      queryParams: {
        page: 1,
        limit: 10,
        status: null,
        type: null,
        startTime: null,
        endTime: null
      },
      // 默认查询最近7天
      dateRange: [this.formatDateTime(new Date(Date.now() - 6 * 24 * 3600 * 1000), true), this.formatDateTime(new Date(), false)],
      detailVisible: false,
      detailTitle: '操作日志详情',
      logDetail: {}
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    formatDateTime: function formatDateTime(date, isStart) {
      var d = new Date(date);
      var pad = function pad(n) {
        return String(n).padStart(2, '0');
      };
      var day = "".concat(d.getFullYear(), "-").concat(pad(d.getMonth() + 1), "-").concat(pad(d.getDate()));
      return isStart ? "".concat(day, " 00:00:00") : "".concat(day, " 23:59:59");
    },
    getList: function getList() {
      var _this = this;
      this.loading = true;
      var params = {
        page: this.queryParams.page,
        limit: this.queryParams.limit,
        status: this.queryParams.status,
        type: this.queryParams.type,
        startTime: this.queryParams.startTime,
        endTime: this.queryParams.endTime
      };
      if (this.dateRange && this.dateRange.length === 2) {
        params.startTime = this.dateRange[0];
        params.endTime = this.dateRange[1];
      }
      (0, _syncGoodsLog.getSyncGoodsLogList)(params).then(function (response) {
        // 处理返回的数据，转换时间戳和字段名
        _this.logList = response.records.map(function (item) {
          return {
            id: item.id,
            status: item.status,
            type: item.type,
            startTime: _this.formatTimestamp(item.startTime),
            endTime: _this.formatTimestamp(item.endTime),
            createBy: item.createName || item.createBy || '',
            errMsg: item.errMsg || '',
            reqMsg: item.reqMsg || '',
            createTime: _this.formatTimestamp(item.createTime || new Date().getTime())
          };
        });
        _this.total = response.total;
        _this.loading = false;
      }).catch(function () {
        _this.loading = false;
      });
    },
    formatTimestamp: function formatTimestamp(timestamp) {
      if (!timestamp) return '';
      var date = new Date(timestamp);
      return date.toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      });
    },
    handleQuery: function handleQuery() {
      this.queryParams.page = 1;
      this.getList();
    },
    resetQuery: function resetQuery() {
      this.queryParams = {
        page: 1,
        limit: 10,
        status: null,
        type: null,
        startTime: null,
        endTime: null
      };
      this.dateRange = [];
      this.getList();
    },
    handleSizeChange: function handleSizeChange(size) {
      this.queryParams.limit = size;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(current) {
      this.queryParams.page = current;
      this.getList();
    },
    handleDetail: function handleDetail(id) {
      var _this2 = this;
      (0, _syncGoodsLog.getSyncGoodsLogDetail)(id).then(function (response) {
        var item = response.data || response;
        _this2.logDetail = {
          id: item.id,
          status: item.status,
          type: item.type,
          startTime: _this2.formatTimestamp(item.startTime),
          endTime: _this2.formatTimestamp(item.endTime),
          createBy: item.createName || item.createBy || '',
          errMsg: item.errMsg || '',
          reqMsg: item.reqMsg || '',
          createTime: _this2.formatTimestamp(item.createTime || new Date().getTime())
        };
        _this2.detailVisible = true;
      });
    },
    getTypeText: function getTypeText(type) {
      var typeMap = {
        1: '商品全量同步',
        2: '单品同步',
        3: '刷新缓存',
        4: '门店菜单商品上下架',
        5: '商品上下架',
        6: '后台操作解估/估清'
      };
      return typeMap[type] || '';
    }
  }
};